import { NgFor, NgIf, NgOptimizedImage, isPlatformBrowser } from '@angular/common';
import {
  Component, Inject, Input, OnInit, PLATFORM_ID
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import {
  FooterStatistic,
  FooterStatisticService
} from 'src/app/api';
import {
  AppComponent
} from 'src/app/app.component';
import {
  ConsoleLoggerService
} from 'src/app/services/console-logger.service';
import {
  JsonService
} from 'src/app/services/json-service.service';
import Constants from 'src/app/utils/Constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor, RouterLink, NgOptimizedImage]
})
export class FooterComponent implements OnInit {
  // INPUT GESTIONE IFRAME
  @Input() order: number;

  constructor(public main: AppComponent, private jsonService: JsonService, private footerAPI: FooterStatisticService, @Inject(PLATFORM_ID) private platformId: object, private consoleLog: ConsoleLoggerService) {
  }

  // SEZIONI GENERICHE
  public levelSezioni = ['vendita', 'affitto', 'agenzia', 'agente', 'professionista'];
  public indexSezioni = 0;

  // LISTA DI TIPOLOGIE DI IMMOBILI E AGENZIE
  lT: any = Constants.LIST_OF_TYPOLOGY;
  lC: any = Constants.LIST_OF_COMPANY;
  lP: any = [{
    text: 'Consulenti del credito',
    value: ['consulenteDelCredito'],
  }];
  public levelTipologie = this.lC;
  public indexTipologie = -1; // PRESELEZIONATO TUTTE

  // REGIONI E PROVINCE
  public levelProvince = [];

  // mostra nasconde parte alta ricerca del footer
  @Input() isPrimaryFooter = true;

  async ngOnInit(): Promise<void> {
    this.levelTipologie = this.lT;
    try {
      let footerData: FooterStatistic;
      // if (isPlatformBrowser(this.platformId)) {
      //   if (localStorage.getItem('footerCercacasaTimeStamp')) {
      //     const lastUpdate = parseInt(localStorage.getItem('footerCercacasaTimeStamp'), 10);
      //     const now = new Date().getTime();
      //     if ((now - lastUpdate) / 3600000 > Constants.HOUR_OF_EXPIRATION_FOOTER) {
      //       footerData = await this.getFooterData();
      //     }
      //     else {
      //       footerData = JSON.parse(localStorage.getItem('footerCercacasa'));
      //     }
      //   }
      //   else {
      //     footerData = await this.getFooterData();
      //   }
      // }
      // else { //TODO: capire come gestire in maniera ottimale
      footerData = await this.getFooterData();
      // }
      if (footerData) {
        const array = footerData.data.sort((a, b) => (a.name > b.name ? 1 : -1));
        const div = Math.round(array.length / 4);
        // DIVIDO LE PROVINCE IN 4 ARRAY DELLA STESSA LUNGHEZZA
        this.levelProvince.push(array.splice(0, div));
        this.levelProvince.push(array.splice(0, div));
        this.levelProvince.push(array.splice(0, div));
        this.levelProvince.push(array.splice(0, array.length));
      }
    } catch (e) {
      this.consoleLog.log(e);
    }
  }

  async getFooterData(): Promise<FooterStatistic> {
    const success = await lastValueFrom(this.footerAPI.footerStatisticGetData());
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('footerCercacasa', JSON.stringify(success));
      localStorage.setItem('footerCercacasaTimeStamp', new Date().getTime().toString());
    }
    return success;
  }

  selectSezione(index: number): void {
    this.levelTipologie = [];
    if (index === 2 || index === 3) {
      this.levelTipologie = this.lC;
    }
    else if (index === 0 || index === 1) {
      this.levelTipologie = this.lT;
    }
    else if (index === 4) {
      this.levelTipologie = this.lP;
    }
    this.indexSezioni = index;
    this.indexTipologie = -1;
  }

  selectTipologie(index: number): void {
    this.indexTipologie = index;
  }

  // COMPONE L'URL DELLA RICERCA DELLA PROVINCIA
  composeUrl(item: any): string {
    let type: string;
    try {
      type = this.levelTipologie[this.indexTipologie].value.map((obj: any) => obj.value).join(',');
    } catch (error) {
      type = '';
    }


    return ('/' + this.levelSezioni[this.indexSezioni] + this.main.generateSearchURL(null, item.name, null, null, null, type, null, null));
  }

  getSelectedData(item): any {
    const sezione = this.levelSezioni[this.indexSezioni];
    const tipologia = this.indexTipologie !== -1 && this.levelTipologie[this.indexTipologie] && this.levelTipologie[this.indexTipologie].id ? this.levelTipologie[this.indexTipologie].id : 'tutte';

    if (item[sezione] && item[sezione][tipologia]) {
      return item[sezione][tipologia];
    }
    else {
      return 0;
    }
  }
}
